export default "__VITE_ASSET__0d1c7e53__"